var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02157 1H23.2484C24.3653 1 25.27 1.90468 25.27 3.02157V17.1837C25.27 18.3006 24.3653 19.2053 23.2484 19.2053H3.02157C1.90468 19.2053 1 18.3006 1 17.1837V3.02157C1 1.90468 1.90468 1 3.02157 1Z",
    stroke: "#74B743",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.0862H8.1816C8.66186 9.0862 9.07511 9.42127 9.16446 9.89036C9.63355 12.0795 11.7891 13.4867 13.9783 13.0177C15.5419 12.6826 16.7705 11.454 17.1055 9.89036C17.1949 9.42127 17.6081 9.07503 18.0884 9.0862H25.27",
    stroke: "#74B743",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.04297H25.27",
    stroke: "#74B743",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountNumber);
export default __webpack_public_path__ + "static/media/AccountNumber.3b100727b0e6991d8ef01ab3c44286e0.svg";
export { ForwardRef as ReactComponent };